// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(async function () {

	// Write your Javascript code here using the Velo framework API

	// Print hello world:
	// console.log("Hello world!");

	// Call functions on page elements, e.g.:
	// $w("#button1").label = "Click me!";

	// Click "Run", or Preview your site, to execute your code
	let x = await $w('#productPage1').getProduct()
	console.log(x)

});